module.exports = __webpack_public_path__ + "static/media/orange.2df467b3.png";